import UltMeta, { Meta } from "./UltMeta/index";

class InvoiceState extends UltMeta {
    INVOICE = new Meta(2, "是", "color-info");
    NOT_INVOICE = new Meta(1, "否", "color-black");
}
export const INVOICE_STATE = new InvoiceState();

class ReconciliationState extends UltMeta {
    ALL = new Meta(0, "全部");
    DRAFT = new Meta(1, "草稿", "");
    SIGNING = new Meta(2, "签署中", "");
    REJECTED = new Meta(3, "已驳回", "");
    FINISHED = new Meta(4, "已完成", "color-info");
    INVALIDING = new Meta(5, "作废中");
    INVALID = new Meta(6, "已作废");
}
export const RECONCILIATION_STATE = new ReconciliationState();

class ReconciliationType extends UltMeta {
    ONE = new Meta(1, "直采-供应商");
    TWO = new Meta(2, "联合采购-联合购销商");
    THREE = new Meta(3, "联合采购-下游采购商");
}
export const RECONCILIATION_TYPES = new ReconciliationType();

class ReconciliationQueryType extends UltMeta {
    ONE = new Meta(1, "作为供货单位");
    TWO = new Meta(2, "作为对账单位");
}
export const RECONCILIATION_QUERY_TYPE = new ReconciliationQueryType();
